import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import LoaderButton from "../components/LoaderButton";
import { API } from "aws-amplify";
import { useAppContext } from "../libs/contextLib";
import { formatJpDateFromString, getAnnualFeeStatusName } from "../libs/utilsLib";
import "./MyPage.css";

export default function MyPage() {
  const search = useLocation().search;
  const mtl = new URLSearchParams(search).get('mtl'); // Member Type Label
  useEffect(() => {
    console.log('load mypage');
    const onLoad = async () => {
      console.log('onLoad called...');
      const fs = await loadFees();
      console.log(fs);
      setFees(fs);
      const fy = currentFiscalYear();
      console.log('fiscal year: ' + fy);
      console.log(typeof fy);
      setFiscalYear(fy);
    };
    onLoad();
  },[]);

  const history = useHistory();
  const { userProfile } = useAppContext();
  const [pageTitle, setPageTitle] = useState('');
  const [fees, setFees] = useState([]);
  const [fiscalYear, setFiscalYear] = useState(2020);

  function loadFees() {
//    console.log(`/fees?mid=${year}`);
    return API.get("sakurajima", `/fees?mid=${userProfile.attributes.preferred_username}`); 
  }

  const handleDummySubmit = (e) => {
    e.preventDefault();
  };

  const popBack = (e) => {
      console.log('pop back');
      history.push('/home');
  };

  const currentFiscalYear = () => {
      const today = new Date();
      console.log(today);
      const fyp = new Date(Date.parse('' + today.getFullYear() + '-10-01T00:00:00+09:00'));
      console.log(fyp);
      console.log('full year = ' + today.getFullYear()); 
      return today < fyp ? today.getFullYear()-1 : today.getFullYear();
  };

  return (
    <div className="MyPage">
      <h1 id="page_title">{ mtl }  マイページ</h1>
      <div className="container">
        <div id="sub_page">
          <div id="mypage" className="list">
              <section>
                <h2>年会費納入状況確認</h2>
                <div className="inner">
                  <Table>
                    <tbody>
                      <tr>
                        <th>年度</th>
                        <th>状態</th>
                        <th>入金日</th>
                      </tr>
                   {fees.map(({pk,sk,data, familyName, givenName, affiliationName, status, dateOfPayment, admissionDate, year}, index) => (
                      <tr className={ year > fiscalYear ? "fiscalYearHiddenNG" : "" }>
                        <td>
                           {year} 年度会員
                        </td>
                        <td>
                           {getAnnualFeeStatusName(status)}
                        </td>
                        <td>
                           {formatJpDateFromString(dateOfPayment)}
                        </td>
                      </tr>
		   ))}
                    </tbody>
                  </Table>
                </div>
                  <Form onSubmit={popBack}>
                    <LoaderButton
                      block
                      size="lg"
                      type="submit"
                      variant="success"
                      isLoading={false}
                      id="confirm"
                      disabled={false}
                  >
                  戻る
                    </LoaderButton>
                  </Form>
              </section>
          </div>
        </div>
      </div>
    </div>
  );
}
